module.exports = __webpack_public_path__ + "img/float-btn-esports.ab7716b0.svg";